import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/algorithm-tools/')({
  beforeLoad: () => {
    redirect({
      to: '/algorithm-tools/offline-sales-optimizer',
      search: (prev) => ({
        ...prev,
        opt: 'diag',
        diag: 'perf',
        iex: 'vol',
      }),
      throw: true,
      replace: true,
    });
  },
});
